export default "__VITE_ASSET__B$7sJA54__"